module.exports = __webpack_public_path__ + "img/xinpin.2388a36a.png";